import { guideSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function AccessGuide() {
  return (
    <section id="guide" className="w-full scroll-mt-20 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="防屏蔽访问指南"
          title="四步走，网址失效也能快速找回入口"
          desc="不需要任何工具，按下面的顺序操作，就能稳定进入久久视频，追剧不再因为链接变动而中断。"
        />

        <ol className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step) => (
            <li
              key={step.step}
              className="rise relative rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={`${step.icon} text-2xl`}></i>
              </span>
              <span className="absolute right-5 top-5 font-heading text-2xl font-black text-background-300">
                {step.step}
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}